import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1bc8bhtc7s: FaireBrandEntity = {
  token: "b_1bc8bhtc7s",
  type: "brand",
  name: "Boutique Monogram",
  avatarUrl:
    "https://cdn.faire.com/fastly/8e5c2e4ab3ebce35f86085e57bfc1b88989d99cd4d0509d318071c3283f97185.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/22031585d2fc2b7039f20cc12eab24fa62770526d2b93015b18a9db98d437236.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8e5c2e4ab3ebce35f86085e57bfc1b88989d99cd4d0509d318071c3283f97185.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/22031585d2fc2b7039f20cc12eab24fa62770526d2b93015b18a9db98d437236.png",
  location: "CA, USA",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 51,
  isInsider: true,
  description:
    "Our Faire location specializes in an offering of small quantities to stylish retailers in over 1,100 shops nationwide. Our handmade in the USA process lends the ability to produce a few items at a time and pass those benefits on to chic boutiques who cater to the trendy customer. Our Faire shop does not ship with packaging or barcoded labels but we offer this on alternative platforms with larger minimums. \n\nWelcome! I'm a US based graphic designer with a passion for creating bold, colorful patterns that bring joy to everyday life. For over 14 years, I've been personalizing gifts and accessories with my unique designs.\n\nToday, my items are proudly carried in more than 1,100 boutiques and retail locations across the country and have been featured in collaborations with the MLB, The Paper Store, Hallmark, and other leading retailers.\n\nThank you for visiting and I hope you find something that makes you smile!\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:46.395Z",
    importedBy: "entity-db-cli",
  },
};
